<template>
	<transition name="opacity">
		<aside
			v-show="isShow"
			:class="[
				'bs-dialog-revamp',
				{ isFullInMobile: isFullInMobile, 'background-blur': isBackgroundBlur },
			]"
		>
			<div
				class="bs-overlay bs-overlay--full bs-overlay--revamp"
				@click="hideByClickOverlay"
			></div>
			<div :class="['bs-dialog-revamp-container', size]">
				<div
					class="bs-dialog-revamp__header"
					:class="{
						'bs-dialog-revamp__header__second-layer': isSecondLayer,
					}"
					v-if="slots.header"
				>
					<slot name="header" />
					<button
						class="bs-icon bs-dialog-revamp__close"
						@click="clickDefaultClose"
						tabindex="0"
						v-if="isShowDefaultClose"
					>
						<BaseIcon
							:name="'close_v1'"
							class="h-24px w-24px cursor-pointer fill-n-950"
						/>
					</button>
				</div>
				<div class="bs-dialog-revamp__body">
					<slot name="content" />
				</div>
				<div class="bs-dialog-revamp__footer" v-if="slots.footer">
					<slot name="footer" />
				</div>
				<div class="bs-dialog-revamp__fixed-footer" v-if="slots.fixed_footer">
					<slot name="fixed_footer" />
				</div>
			</div>
		</aside>
	</transition>
</template>

<script lang="ts" setup>
import { useSlots } from 'vue'
import useOverlay from '@/legacy/ts/useOverlay'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'
import { checkIsPhActivation } from '@/lib/checkService'

const props = defineProps({
	modelValue: {
		type: Boolean,
		default: false,
	},
	size: {
		type: String,
		// lg, md, sm
		default: 'md',
	},
	isShowDefaultClose: {
		type: Boolean,
		default: true,
	},
	canCloseDialogByOverlay: {
		type: Boolean,
		default: true,
	},
	isFullInMobile: {
		type: Boolean,
		default: false,
	},
	isCustomOverlayFunction: {
		type: Boolean,
		default: false,
	},
	isSecondLayer: {
		type: Boolean,
		default: false,
	},
	isCustomCloseFunction: {
		type: Boolean,
		default: false,
	},
})

const slots = useSlots()
const updateModelValue = (value: boolean) => {
	emit('update:modelValue', value)
}
const { isShow, hide } = useOverlay(props, updateModelValue)
const isBackgroundBlur = checkIsPhActivation()

const emit = defineEmits([
	'overlayClick',
	'update:modelValue',
	'defaultCloseClick',
])
const hideByClickOverlay = () => {
	if (props.isCustomOverlayFunction) {
		emit('overlayClick')
		// return
	}
	if (props.canCloseDialogByOverlay) {
		hide()
	}
}

function clickDefaultClose() {
	if (props.isCustomCloseFunction) {
		emit('defaultCloseClick')
	} else {
		hide()
	}
}
</script>
